import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/types';

interface ComicCardProps {
  comic: Comic;
  size?: 'small' | 'medium' | 'large';
}

export default function ComicCard({ comic, size = 'medium' }: ComicCardProps) {
  const formatViews = (views: number) => {
    if (views >= 10000000) return `${(views / 10000000).toFixed(1)}千万`;
    if (views >= 10000) return `${(views / 10000).toFixed(1)}万`;
    return views.toString();
  };

  const sizeClasses = {
    small: 'w-[140px]',
    medium: 'w-[160px]',
    large: 'w-[180px]',
  };

  const coverHeights = {
    small: 'h-[196px]',
    medium: 'h-[224px]',
    large: 'h-[252px]',
  };

  return (
    <Link
      to={`/comic/${comic.id}`}
      className={`${sizeClasses[size]} group block flex-shrink-0`}
    >
      {/* Cover */}
      <div className={`${coverHeights[size]} relative overflow-hidden rounded-lg mb-2.5`}>
        <img
          src={comic.cover}
          alt={comic.title}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
        <div className="absolute bottom-0 left-0 right-0 p-2.5">
          <span className={`inline-block px-2 py-0.5 rounded text-[10px] font-medium ${
            comic.status === '连载中'
              ? 'bg-primary-500/90 text-white'
              : 'bg-background-800/70 text-background-100'
          }`}>
            {comic.status}
          </span>
        </div>
        <div className="absolute top-2 right-2 bg-black/60 backdrop-blur-sm px-1.5 py-0.5 rounded text-[10px] text-amber-400 font-semibold">
          {comic.rating}
        </div>
      </div>

      {/* Info */}
      <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1 leading-snug">
        {comic.title}
      </h3>
      <p className="text-xs text-foreground-500 mt-0.5 line-clamp-1">
        {comic.author}
      </p>
      <p className="text-[10px] text-foreground-400 mt-0.5">
        {formatViews(comic.views)} 阅读
      </p>
    </Link>
  );
}